"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnyValidator = void 0;
const validator_1 = require("./validator");
class AnyValidator extends validator_1.CommonValidator {
    merge(props) {
        return new AnyValidator({ ...this.props, ...props });
    }
    validateValue() {
        return Promise.resolve();
    }
}
exports.AnyValidator = AnyValidator;
